export default {
  methods: {
    handleSubmitError(error) {
      let message = this.$t('messages_nl.api.response.status.badRequest');
      if (error.response
        && error.response.data
        && error.response.data.data
        && error.response.data.data.message !== undefined
      ) {
        message = error.response.data.data.message;
      }
      this.$store.dispatch('addFlash', {
        type: 'danger',
        message,
      });
    },
  },
};
